import React from 'react';
import ClassroomModal from './ClassroomModal';
import type { LevelBriefing } from '../../classroom/missionLayers';
import { printWorksheet } from '../../classroom/printWorksheet';

interface TeachersNotesModalProps {
  isOpen: boolean;
  levelTitle: string;
  briefing: LevelBriefing;
  onClose: () => void;
}

/** Whole-class orientation: summary, optional video, worksheet, mission arc. */
const TeachersNotesModal: React.FC<TeachersNotesModalProps> = ({
  isOpen,
  levelTitle,
  briefing,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <ClassroomModal isOpen={isOpen} title="Teacher’s Notes" onClose={onClose} width={520}>
      <div className="cd-briefing">
        <p className="cd-briefing-level">{levelTitle}</p>

        {briefing.videoUrl ? (
          <section className="cd-briefing-slot">
            <div className="cd-briefing-slot-label">One-minute brief</div>
            <video
              className="cd-briefing-video"
              src={briefing.videoUrl}
              controls
              playsInline
              preload="metadata"
            />
          </section>
        ) : null}

        <section className="cd-briefing-slot">
          <div className="cd-briefing-slot-label">Today</div>
          {briefing.teacherNotes ? <div className="cd-rich-text" dangerouslySetInnerHTML={{ __html: briefing.teacherNotes }} /> : <p className="cd-briefing-summary">{briefing.summary}</p>}
        </section>

        {briefing.iCanStatement ? (
          <section className="cd-briefing-slot">
            <div className="cd-briefing-slot-label">I can statement</div>
            <p className="cd-briefing-summary">I can {briefing.iCanStatement}</p>
          </section>
        ) : null}

        {briefing.additionalNotes ? (
          <section className="cd-briefing-slot">
            <div className="cd-briefing-slot-label">Additional notes</div>
            <div className="cd-rich-text" dangerouslySetInnerHTML={{ __html: briefing.additionalNotes }} />
          </section>
        ) : null}

        {briefing.worksheet ? (
          <section className="cd-briefing-slot">
            <div className="cd-briefing-slot-label">Worksheet</div>
            <p className="cd-briefing-worksheet-copy">{briefing.worksheet.title}</p>
            <button
              type="button"
              className="cd-btn cd-btn-compact"
              onClick={() => printWorksheet(briefing.worksheet!)}
            >
              View / Print
            </button>
          </section>
        ) : null}

        <section className="cd-briefing-slot">
          <div className="cd-briefing-slot-label">Lesson arc</div>
          <ol className="cd-notes-arc">
            {briefing.missions.map((m) => (
              <li key={m.id}>
                <span className="cd-notes-arc-title">{m.title}</span>
                <span className="cd-notes-arc-meta">
                  {m.plannedMinutes != null ? `${m.plannedMinutes} min` : ''}
                  {m.priority === 'flex' ? ' · flex' : ''}
                </span>
              </li>
            ))}
          </ol>
        </section>
      </div>
    </ClassroomModal>
  );
};

export default TeachersNotesModal;
